/* eslint-disable camelcase */
import React, { Component } from 'react';
// import {  Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import UpComingChallenges from '../ContentV3/UpComingChallenges';
import UpComingEvents from '../ContentV3/UpcomingEvents';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { BirthdayCard, WorkAnniversaryCard } from '../index'
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { StyledModal, StyledHeader, StyledBody, CloseIcon, HeaderText, TopSection, MiddleSection, PeerButton, ImageSection, UploadImage2, UploadImage3 } from './styles';
import TaskToCompleteV3 from '../TaskToCompleteV3';
import {
  SocialFeedsContainer, ContentContainer, InputFieldContainer, SideBarContainer, TileContainer, TitleContent, SideBarContent,
  StyledImage, NotificationDescription, NoComments, Layout, NoFriendRequests, NoActivityFeeds, FeedsContainer, CommentSection, ScrollableFeedsContainer, AssessmentContainer, TipInformation, ButtonWrapper, PostWrapper, PhotoWrapper, RecognitionWrapper, LinkContainer, Link, LinkTab, PictureDiv
} from '../SocialFeedsV2/styles';
import { PageTitle } from '../CreateEvent/styles';
import SingleFeed from '../SocialFeedsV2/SingleFeed';
import Comments from '../Comments';
import Loading from '../Loading';
import { imageErrorMessage } from '../../utils/constants';
import { checkImage, applyHighlights } from '../../utils/methods';
import Image from '../Image';
import { getUserProfileImage, addCommentReplyOnPost, addSocialInspiration, getCommentsOnPost, getUsersToShoutout, getSuggestionsList, getUserName, getUserProfile } from '../../redux/actions';
import SocialFeedTextarea from '../SocialFeedsV2/socialfeedTextAreaPost';
import { HraIcon } from '../DailyTip/styles';
import SuggestionForYou from '../SuggestionForYou';
import { revokeDevice, editSocialInspiration, addCommentOnPost } from '../../redux/actions';
import { ImageUrl } from '../../utils/constants';
// import { UploadImage } from '../SocialFeedsV2/AddBuddyPopUp/styles';
import { withTranslation } from 'react-i18next';

class SocialFeedV2 extends Component {
  constructor(props) {
    super(props);
    const { editPostStatus, editDetails } = props;
    this.state = {
      imgSrc: editPostStatus && editDetails.image ? `https://s3.amazonaws.com/images.trainingamigo.com/${editDetails.image}` : "",
      inspirationQuote: editPostStatus ? editDetails.description : '',
      showCommentsFor: '',
      pageNumber: 1,
      showEditDeletePopup: '',
      editDetails: editDetails,
      editAndDelete: false,
      isUploadedImage: false,
      refreshFileReader: false,
      position: { start: 0, end: 0 },
      imgSrcArray:editPostStatus && editDetails.post_images && editDetails.post_images.length > 0 ? this.getImageDetails(editDetails.post_images) : [],
      mentionedUsers: editPostStatus && editDetails.mentioned_users.length > 0 ? this.getTaggedUserDetails(editDetails.mentioned_users, 0) : [],
      shoutoutType: 0,
      users: editPostStatus && editDetails.mentioned_users.length > 0 ? this.getTaggedUserDetails(editDetails.mentioned_users, 3) : '',
      showGivenShoutout: editPostStatus && editDetails.shoutout_user_name !== null ? true : false,
      shoutoutImage: editPostStatus && editDetails.recognition_image !== null ? editDetails.recognition_image : null,
      shoutoutText: editPostStatus && editDetails.core_value !== null ? editDetails.core_value : null,
      userIdArray: editPostStatus && editDetails.mentioned_users.length > 0 ? this.getTaggedUserDetails(editDetails.mentioned_users, 0) : [],
      taggedUser: editPostStatus && editDetails.mentioned_users.length > 0 ? this.getTaggedUserDetails(editDetails.mentioned_users, 1) : '',
      postDisabled: true,
      exemplifyID: editPostStatus && editDetails.mentioned_users.length > 0 ? editDetails.mentioned_users[0].exemplify_id : null,
      activeLink: 0,
      showConnectDevice: false,
      showPhotoPostModal: false,
      showAllRecogntion: false,
      user: null,
      ShowEmojiContainer: false,
      displayEmoji: false,
      usersV2: [],
      userIdArrayV2: editPostStatus && editDetails.mentioned_users.length > 0 ? this.getTaggedUserDetails(editDetails.mentioned_users, 0) : [],
    };
    this.myref = React.createRef();
    this.emojiref = React.createRef();

  }

  getTaggedUserDetails = (users, status = 1) => {
    let taggedUser = '';
    let userIds = [];
    let userNames = [];
    users.forEach((user, index) => {
      userIds.push(user.uid);
      userNames.push(user.fullname);
      taggedUser += (index === users.length - 1) ? user.fullname : `${user.fullname}, `
    })
    return status === 3 ? userNames : status === 1 ? taggedUser : userIds;
  }

  getImageDetails = (users) => {
    let images = [];
    users.forEach((user) => {
      images.push(`${ImageUrl}/${user.image}`);
    })
    return images;
  }

  handleClick = (event) => {
    if (!isNull(this.myref) && !isUndefined(this.myref) && !isNull(this.myref.current) && !isUndefined(this.myref.current) && !(this.myref && this.myref.current && this.myref.current.contains(event.target))) {
      this.setState({ showConnectDevice: false });
    }
  };
  handleEmojiClick = (event) => {
    if (!isNull(this.emojiref) && !isUndefined(this.emojiref) && !(this.emojiref && this.emojiref.current && this.emojiref.current.contains(event.target))) {
      // this.setState({displayEmoji: false});
    }
  };

  handleRecogntionPopup = () => {
    this.setState((prev) => ({
      showAllRecogntion: !prev.showAllRecogntion,
    }));
  };

  displayEmojiContainer = () => {
    this.setState((prev) => ({
      ShowEmojiContainer: !prev.ShowEmojiContainer
    }));
  }

  showEmojiPicker = () => {
    this.setState((prev) => ({
      displayEmoji: !prev.displayEmoji
    }))
  }
  hideEmojiPicker = () => {
    this.setState({
      displayEmoji: false
    })
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick);
    document.addEventListener("mousedown", this.handleEmojiClick);

    const { profileImage, fetchUserProfileImage, getSuggestionsList, getUserProfileDetails } = this.props;
    getSuggestionsList();
    getUserName();
    getUserProfileDetails();
    if (!profileImage) {
      fetchUserProfileImage();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
    document.addEventListener("mousedown", this.handleEmojiClick);

  }

  openEditAndDelete = () => {
    this.setState({
      editAndDelete: !this.state.editAndDelete
    })
  };

  changeEditDeletePopup = (value, feed) => {
    this.setState({ editDetails: feed }, () => {
      this.setState({ showEditDeletePopup: value });
    });
  };

  onHideEditDeletePopup = () => {
    this.setState({
      showEditDeletePopup: ''
    }, () => {
      this.openEditAndDelete();
    })
  };
  removeImage = (src) => {
    let arrayy = this.state.imgSrcArray.filter((item) => item !== src)
    this.setState({
      imgSrcArray: arrayy,
      refreshFileReader: false
    });
  }

  onChange = (e) => {
    let files = e.target.files;
  
    if (files && files.length > 0) {
      for (let i = 0; i < Math.min(files.length, 5); i++) {
        if (checkImage(files)) {
          if ((files[i]?.size / 1000000) <= 20) {
            let reader = new FileReader();
            reader.readAsDataURL(files[i]);
            reader.onloadend = () => {
              this.setState({
                imgSrcArray: [...this.state.imgSrcArray, reader.result],
                refreshFileReader: true
              });
            };
          } else {
            toast.error('Please select image file less than 20MB');
            document.getElementById('uploadPhoto') && (document.getElementById('uploadPhoto').value = '');
          }
        } else {
          toast.error(imageErrorMessage);
          document.getElementById('uploadPhoto') && (document.getElementById('uploadPhoto').value = '');
        }
      }
      // Reset the input value to allow re-selection of the same file
      e.target.value = '';
    }
  };

  toCodePoints = function (string) {
    let chars = "";
    for (let i = 0; i < string.length; i++) {
      let c1 = string.charCodeAt(i);
      let b1 = string.charAt(i);
      if (c1 >= 0xD800 && c1 < 0xDC00 && i + 1 < string.length) {
        let c2 = string.charCodeAt(i + 1);
        if (c2 >= 0xDC00 && c2 < 0xE000) {
          chars = chars + ("&#" + ((+0x10000 + ((c1 - 0xD800) << 10) + (c2 - 0xDC00))) + ";");
          i++;
          continue;
        }
      }
      else {
        chars = chars + b1;
      }
    }
    return chars;
  }

  getCommentsForPost = (id) => {
    const { fetchCommentsOnPost } = this.props;
    this.setState({
      showCommentsFor: id
    });
    fetchCommentsOnPost(id);
  };

  onScroll = (e) => {
    const { pageNumber } = this.state;
    const { count, feeds } = this.props;
    const bottom = Math.round(e.target.scrollHeight - parseInt(e.target.scrollTop,10)) === Math.round(e.target.clientHeight);
    if (bottom && feeds &&feeds.response&& feeds.response.length < count) {
      this.setState({
        pageNumber: pageNumber + 1
      }, () => {
        this.props.loadMoreFeeds(this.state.pageNumber);
      });
    }
  };

  showRecognitionPopupCall = () =>{
    this.props.showRecognitionPopup();
    this.hideEmojiPicker();
  }

  renderFeeds = (feeds) => {
    const { showCommentsFor, editAndDelete } = this.state;
    const { isLoading, comments, replySuccess, postReplyOnComment, profileImage, history, enableTrigger } = this.props;
    return (
      <div>
        {
          feeds && feeds.length > 0 ?
            <ScrollableFeedsContainer onScroll={this.onScroll}>
              {
                feeds.map((feed, index) => (
                  <FeedsContainer key={index}>
                    <SingleFeed
                      feed={feed}
                      description={feed.description}
                      taggedUsers={feed.shoutout_user_name}
                      getCommentsForPost={this.getCommentsForPost}
                      changeEditDeletePopup={this.changeEditDeletePopup}
                      editAndDelete={editAndDelete}
                      openEditAndDelete={this.openEditAndDelete}
                      profileImage={profileImage}
                      updationList="response"
                      commentCount={feed.comment_count}
                      history={history}
                      enableTrigger={enableTrigger}
                    />
                    {showCommentsFor === feed.id &&
                      (isLoading ? <Loading isHorizontal /> :
                        (isEmpty(comments) ? <NoComments>No Comments to display</NoComments> :
                          <Comments
                            comments={comments}
                            postReply={postReplyOnComment}
                            replySuccess={replySuccess}
                            id={feed.id}
                            history={history}
                            enableTrigger={enableTrigger}
                          />))}
                  </FeedsContainer>
                ))
              }
            </ScrollableFeedsContainer> : <NoComments>No posts in this section</NoComments>

        }
      </div>
    )
  };

  addInspiration = (e) => {
    let position = this.getPosition(e.target);
    this.setState({
      position: position,
      inspirationQuote: e.target.value,
    });
  };

  getPosition(el) {
    let start = 0, end = 0, normalizedValue, range,
      textInputRange, len, endRange;

    if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end
    };
  }
  addInspirationV2 = (e) => {
    let newText = this.state.inspirationQuote.substr(0, this.state.position.start) + e + this.state.inspirationQuote.substr(this.state.position.end);
    this.setState({
      position: { start: this.state.position.start + e.length, end: this.state.position.end + e.length },
      inspirationQuote: newText,
    });
  };

  updateText = (text, userId, taggedUserName) => {
    const { userIdArray, users, taggedUser } = this.state;
    let userIdArr = [...userIdArray];
    let userNameArr = [...users];
    let taggedUsers = taggedUser;
    if (userIdArr.indexOf(userId) === -1) {
      userIdArr.push(userId);
      userNameArr.push(taggedUserName);
      if (_.isEmpty(taggedUsers))
        taggedUsers = `${taggedUsers}, ${taggedUserName}`;
      // else
      // taggedUsers = taggedUserName;
    }
    this.setState({
      inspirationQuote: text,
      userIdArray: userIdArr,
      users: userNameArr,
      position:{start:text.length,end:text.length}
      // taggedUser: taggedUsers,
      // showGivenShoutout: bool
    });
  };

  updateTextV2 = (text, userId, taggedUserName, bool) => {
    const { userIdArrayV2, usersV2, taggedUser, userIdArray } = this.state;
    let userIdArr = [...userIdArrayV2];
    let userNameArrV2 = [...usersV2];
    let userIdAll = [...userIdArray]
    let taggedUsers = taggedUser;
    if (userIdArr.indexOf(userId) === -1) {
      userIdArr.push(userId);
      userIdAll.push(userId);
      userNameArrV2.push(taggedUserName);
      if (!_.isEmpty(taggedUsers))
        taggedUsers = `${taggedUsers}, ${taggedUserName}`;
      else
        taggedUsers = taggedUserName;
    }
    this.setState({
      userIdArrayV2: userIdArr,
      usersV2: userNameArrV2,
      taggedUser: taggedUsers,
      showGivenShoutout: bool,
      userIdArray: userIdAll
    });
  };

  onShoutoutSelect = (text, id, image) => {
    const { userIdArray } = this.state;
    this.updateShoutoutArray(userIdArray, text, image, id);
  };

  updateShoutoutArray = (mentionedUsers, text, image, exemplify_id) => {
    this.setState({
      mentionedUsers: mentionedUsers,
      showGivenShoutout: true,
      shoutoutText: text,
      shoutoutImage: image,
      shoutoutType: exemplify_id ? exemplify_id : null,
      exemplifyID: exemplify_id ? exemplify_id : null,
      showAllRecogntion: !this.state.showAllRecogntion,

    });
  };

  onRemoveShoutout = (array) => {
    this.setState({
      [array]: [],
      showGivenShoutout: false,
      taggedUser: '',
      shoutoutImage: null,
      shoutoutText: null,
      userIdArray: [],
      users: [],
      shoutoutType: 0,
      mentionedUsers: [],
      usersV2: '',
      userIdArrayV2: []
    });
  };

  onRemoveUser = () => {
    this.setState({
      taggedUser: '',
      showGivenShoutout: false,
      userIdArray: [],
      shoutoutImage: null,
      shoutoutText: null,
      users: []
    });
  };

  renderInputField = (placeholder, UpdateStatus, isCommentOrReply) => (
    <InputFieldContainer UpdateStatus={UpdateStatus}>
      <PictureDiv>
        <img src="../../../public/images/social/userIcon.png" />
      </PictureDiv>
      <SocialFeedTextarea
        userCompany={this.props.userCompany}
        addInspiration={this.addInspiration}
        inspirationQuote={this.state.inspirationQuote}
        updateText={this.updateText}
        users={this.state.users}
        userIdArray={this.state.userIdArray}
        placeholder={placeholder}
        showGivenShoutout={this.state.showGivenShoutout}
        updateShoutoutArray={this.updateShoutoutArray}
        emptyShoutoutArray={this.emptyShoutoutArray}
        onRemoveShoutout={this.onRemoveShoutout}
        isCommentOrReply={isCommentOrReply}
        shoutoutText={this.state.shoutoutText}
        shoutoutImage={this.state.shoutoutImage}
        taggedUser={this.state.taggedUser}
        onRemoveUser={this.onRemoveUser}
        enableTrigger={this.props.enableTrigger}
        ShowEmojiContainer={this.state.ShowEmojiContainer}
        showEmojiPicker={this.showEmojiPicker}
        displayEmoji={this.state.displayEmoji}
        emojiref={this.emojiref}
        hideEmojiPicker={this.hideEmojiPicker}


      />
    </InputFieldContainer>
  );

  renderDidYouKnowTip = () => (
    <TileContainer>
      <TitleContent>
        <i className="fas fa-question" />
        <span>&nbsp;Did you know?</span>
      </TitleContent>
      <SideBarContent>
        <span>Did you know that improving your balance can improve your athletic ability?</span>
      </SideBarContent>
    </TileContainer>
  );

  acceptOrRejectRequest = (id, status) => {
    const { acceptOrRejectFriendRequest } = this.props;
    acceptOrRejectFriendRequest({ request_id: id, status: status });
  };

  renderFriendRequests = (requests) => (
    <TileContainer>
      <TitleContent isClickable onClick={() => this.showModal()}>
        <i className="fas fa-user" />
        <span>Friend Requests:</span>
      </TitleContent>
      {
        requests.length > 0 ?
          <SideBarContent isClickable>
            {requests.map((request, index) => (
              <div key={index} className="image-container" onClick={() => this.showModal()}>
                <Image
                  image={request.profile_image}
                  alt={request.fullname}
                />
              </div>
            ))}
            {this.renderFriendRequestModal()}
          </SideBarContent> :
          <SideBarContent><NoFriendRequests>No friend requests to show</NoFriendRequests></SideBarContent>
      }
    </TileContainer>
  );

  renderActivityFeeds = (feeds) => (
    <TileContainer>
      <TitleContent>
        <i className="fas fa-list" />
        <span>Activity Feed:</span>
        <span><span>{feeds.length}</span>&nbsp;new notifications</span>
      </TitleContent>
      {feeds.length > 0 ? feeds.map((feed, index) => (
        <SideBarContent key={index} notificationSection >
          <StyledImage left>
            <div className="middle">
              <Image image={feed.friend_image} alt={feed.friend_name} />
            </div>
            <NotificationDescription>
              {feed.friend_name} <span className=" lowerCase">{feed.action_type + ' with '}</span>
              {feed.fof_name}
            </NotificationDescription>
          </StyledImage>
        </SideBarContent>
      )) : <NoActivityFeeds>No activities to show</NoActivityFeeds>}
    </TileContainer>
  );

  onHide = () => {
    this.setState({
      // showModal: '',
      imgSrc: ''
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.profileImage != nextProps.profileImage) {
      this.checkBase64(nextProps.profileImage);
    }
  }

  checkBase64(profileImage) {
    if (profileImage) {
      let arr = profileImage.split('/');
      if (arr[0] !== 'profile-Image') {
        this.setState({
          isUploadedImage: true
        })
      }
      else {
        this.setState({
          isUploadedImage: false
        })
      }
    }
  }

  togglePostButton = (value, image) => {
    const { shoutoutText, userIdArray } = this.state;
    if (userIdArray.length !== 0) {
      if (userIdArray.length !== 0 && !_.isNull(shoutoutText)) {
        return false;
      } else
        return true;
    } else if (value && value.trim() !== '' || image !== '') {
      return false;
    }
    return true;
  };

  addPost = () => {
    const { imgSrcArray, mentionedUsers, usersV2, userIdArray, userIdArrayV2, inspirationQuote, taggedUser, exemplifyID } = this.state;
    const { addSocialInspiration, activeTab, onClose, editDetails, editPostStatus, editSocialInspiration, addCommentWithImageStatus, postComment, feedIdForComment, postReplyOnComment, commentId } = this.props;
    let inspirationData = {
      image: imgSrcArray.length > 0 ? imgSrcArray[0] : '',
      post_images: imgSrcArray.length > 0 ? imgSrcArray : [],
      exemplify_id: exemplifyID,
      shoutout: {
        exemplifies: userIdArrayV2
      },
      mentioned_user: userIdArray
    };
    if (addCommentWithImageStatus) {
      inspirationData.comment = inspirationQuote;
      inspirationData.post_id = feedIdForComment;
    } else {
      let html = this.toCodePoints(inspirationQuote);
      inspirationData.description = html;
    }
    if (!_.isEmpty(mentionedUsers) || !_.isEmpty(userIdArray) && usersV2) {
      inspirationData.shoutout_user_name = `${applyHighlights(usersV2, userIdArrayV2, taggedUser)} - ${this.state.shoutoutText}`;
    }
    this.onHide();
    if (editDetails && editPostStatus) {
      editSocialInspiration({
        ...inspirationData,
        recognition_image: editDetails.recognition_image,
        recognition_string: editDetails.recognition_string,
        recognition_text: editDetails.recognition_text,
        shoutout_type: editDetails.shoutout_type,
        id: editDetails.id,
      }, {
        ...inspirationData,
        recognition_image: editDetails.recognition_image,
        recognition_string: editDetails.recognition_string,
        recognition_text: editDetails.recognition_text,
        shoutout_type: editDetails.shoutout_type,
        id: editDetails.id,
      });
    }
    else if (addCommentWithImageStatus === 1) {
      if (feedIdForComment !== '' || inspirationQuote !== '' || inspirationData.description !== "" || inspirationData.image !== "" || inspirationData.shoutout.exemplifies.length >= 1) {
        postComment(inspirationData);
      } else {
        toast.error("Please add the comment details for the post before the send the comment");
      }
    } else if (addCommentWithImageStatus === 2) {
      if (feedIdForComment !== '' || inspirationQuote !== '' || inspirationData.description !== "" || inspirationData.image !== "" || inspirationData.shoutout.exemplifies.length >= 1) {
        postReplyOnComment(commentId, inspirationQuote, feedIdForComment, inspirationData.shoutout, inspirationData.shoutout_user_name, exemplifyID, inspirationData.image);
      }
    }
    else {
      if (inspirationQuote !== '' || inspirationData.description !== "" || inspirationData.image !== "" || inspirationData.shoutout.exemplifies.length >= 1) {
        addSocialInspiration(inspirationData);
      } else {
        toast.error("Please add all the post details before posting");
      }
    }
    let active = activeTab === "Company" ? "Company" : activeTab === "My Amigos" ? "My Amigos": "Everybody";
    this.props.setActiveTab(active);
    this.setState({
      inspirationQuote: '',
      imgSrc: '',
      showGivenShoutout: false,
      shoutoutImage: null,
      shoutoutText: null,
      taggedUser: '',
      userIdArray: [],
      users: [],
      mentionedUsers: [],
      shoutoutType: 0,
    })
    onClose();
  };


  renderAssessmentPanel = () => {
    const { history } = this.props;
    return (
      <AssessmentContainer>
        <TipInformation onClick={() => history.push('/wellness-assessment/medical')}>
          <HraIcon><img src={'/public/images/HRA_icon.svg'} /></HraIcon>
          <span>TAKE THE HEALTH RISK ASSESSMENT</span>
        </TipInformation>
      </AssessmentContainer>
    );
  };

  handleTabSwitch = (index) => {
    this.setState({
      activeLink: index
    })
  }

  toggleConnectDevices = () => {
    this.setState((prev) => ({
      showConnectDevice: !prev.showConnectDevice
    }));
  };

  handlePhotoPostModal = () => {
    this.setState((prev) => ({
      showPhotoPostModal: !prev.showPhotoPostModal
    }));
  };
  renderView = () => {
    const { feeds, history, suggestionList, user } = this.props;
    let Tabs = [
      {
        tabName: "Company"
      },
      {
        tabName: "Buddies"
      },
      {
        tabName: "Recognition"
      }
    ];
    return (
      <Layout>
        <PageTitle>{this.props.t("Update Status")}</PageTitle>
        <ContentContainer>
          <SocialFeedsContainer>
            <CommentSection>
              {this.renderInputField("What's on your mind?", "UpdateStatus")}
              <ButtonWrapper>
                <PostWrapper onClick={() => this.handlePhotoPostModal()}>
                  <img src="../../../public/images/social/post.svg" />
                  <p>{this.props.t("Post")}</p>
                </PostWrapper>
                <PhotoWrapper>
                  <img src="../../../public/images/social/photo.svg" />
                  <p>{this.props.t("Photo")}</p>
                </PhotoWrapper>
                <RecognitionWrapper>
                  <img src="../../../public/images/social/recognition.svg" />
                  <p>{this.props.t("Peer Recognition")}</p>
                </RecognitionWrapper>
              </ButtonWrapper>
            </CommentSection>
            <LinkContainer>
              <Link>
                {
                  Tabs.map((data, index) => (
                    <LinkTab key={index} active={this.state.activeLink === index} onClick={() => this.handleTabSwitch(index)} >
                      {this.props.t(data.tabName)}
                    </LinkTab>
                  ))
                }
              </Link>
            </LinkContainer>
            {this.renderFeeds(feeds)}
          </SocialFeedsContainer>
          <SideBarContainer>
            <BirthdayCard />
            <WorkAnniversaryCard />
            <UpComingChallenges history={history} />
            <UpComingEvents history={history} />
            <TaskToCompleteV3
              history={history}
              user={user}
              displayDeviceModal={this.toggleConnectDevices}
            />
            <SuggestionForYou suggestionList={suggestionList} history={history} />
          </SideBarContainer>
        </ContentContainer>
      </Layout>
    );
  };

  handleSelect = (key) => {
    this.props.setActiveTab(key);
  };

  image = () => (
    this.state.imgSrcArray.map((src, i) => (
      (
        <div className='imageDiv' key={i} >
          <img alt='img' width='150px' height='150px' src={src} />
          <span className='remove' onClick={() => this.removeImage(src)} style={{background:"white", borderRadius:"50%", height:"24px", width:"24px", justifyContent:"center", alignItems:"center", display:"flex"}}><img width='18px' height="18px" src={ImageUrl + "/social-feed/imageCross.png"}></img></span>
        </div>
      )
    )))

  showRecognitionPopup = () =>{
    this.props.hidePhotoVideoPopup();
    this.props.handlePeerModal();
  }

  render() {
    const { profileImage, showModal, onClose, exemplifiesValues, t, editPostStatus,addCommentWithImageStatus } = this.props;
    return (
      <div>
        <StyledModal show={showModal} onHide={onClose} width="550px">
          <StyledHeader background border>
            { editPostStatus? <HeaderText color>{t('Edit Post')}</HeaderText> : addCommentWithImageStatus ? <HeaderText color>{t('Post Comment')}</HeaderText> : <HeaderText color>{t('Create New Post')}</HeaderText>}
            <CloseIcon onClick={onClose}>
              <img src={ImageUrl+"/social-feed/close.png"} width="22px" height="22px"></img>
            </CloseIcon>
          </StyledHeader>
          <StyledBody>
            <TopSection disable={this.state.imgSrcArray.length===0&&!this.state.inspirationQuote&&this.state.userIdArrayV2.length===0?1:0} background>
              {/* {this.renderInputField("What's on your mind?",  "UpdateStatus", "")} */}
              <div style={{ display: 'flex', width: 'auto' }}>
                <PictureDiv>
                  <img src={`${ImageUrl}/${profileImage}`} />
                </PictureDiv>
                <div className='user-namee'>{this.props.user.fname} {this.props.user.lname}</div>
              </div>
              <SocialFeedTextarea
                userCompany={this.props.userCompany}
                addInspiration={this.addInspiration}
                addInspirationV2={this.addInspirationV2}

                inspirationQuote={this.state.inspirationQuote}
                updateText={this.updateText}
                updateTextV2={this.updateTextV2}
                users={this.state.users}
                usersV2={this.state.usersV2}
                userIdArray={this.state.userIdArray}
                placeholder={t("What's on your mind")}
                className={'CustomTextAreaField2'}
                showGivenShoutout={this.state.showGivenShoutout}
                updateShoutoutArray={this.updateShoutoutArray}
                emptyShoutoutArray={this.emptyShoutoutArray}
                onRemoveShoutout={this.onRemoveShoutout}
                //   isCommentOrReply={isCommentOrReply}
                shoutoutText={this.state.shoutoutText}
                shoutoutImage={this.state.shoutoutImage}
                taggedUser={this.state.taggedUser}
                onRemoveUser={this.onRemoveUser}
                enableTrigger={this.props.enableTrigger}
                ShowEmojiContainer={this.state.ShowEmojiContainer}
                showEmojiPicker={this.showEmojiPicker}
                displayEmoji={this.state.displayEmoji}
                emojiref={this.emojiref}
                hideEmojiPicker={this.hideEmojiPicker}
              // selectedImage={this.state.imgSrc}
              />
              <ImageSection>
                {this.state.imgSrcArray.length > 0 && <div className='imageContainer'>
                  {this.image()}
                  {
                    this.state.imgSrcArray.length > 0 && this.state.imgSrcArray.length < 5 && 
                    <UploadImage3 style={{ marginBottom: '10px' }}>
                      <img src={ImageUrl+"/social-feed/addImageIcon.png"}></img>
                      <input
                        id="upload-file"
                        type="file"
                        name="user"
                        multiple={true}
                        onChange={(e) => this.onChange(e)}
                        // onClick={(e) => e.target.files && this.onChange(e)}
                        accept=".jpeg, .png, .jpg"
                        hidden
                      />
                    </UploadImage3>
                  }
                </div>}
              </ImageSection>
              {this.state.imgSrcArray.length > 0&&<div style={{fontFamily:"Rubik", color:"#F4AAA9", fontSize:"14px", marginTop:"15px"}}>*{this.props.t("Only Upload 5 images Max")}</div>}
              <div className='add-post-box' style={{marginTop:this.state.imgSrcArray.length > 0?"15px":"55px"}}>
                {this.state.showAllRecogntion && <MiddleSection>
                  {
                    exemplifiesValues ? (
                      exemplifiesValues.map((data, index) => (
                        <PeerButton key={index} onClick={() => this.onShoutoutSelect(data.core_value, data.id, data.image)}>
                          <img src={`${ImageUrl}/${data.image}`} />
                          <div className="imgDiv">{data.core_value}</div>
                        </PeerButton>
                      ))
                    ) : (null)
                  }
                </MiddleSection>}
                <div style={{ padding: '8px 10px 0px 15px', display: 'flex', justifyContent: 'space-between' }}>
                  <div className='box-title'>{t("Add To Your Post")}</div>
                  <div style={{ display: 'flex' }}>
                    <div style={{background:"white", width:"40px", height:"40px", borderRadius:"50%", display:"flex", marginRight:"10px"}}><img style={{  width: '25px', height: '25px', cursor: 'pointer', margin:"auto", display:"flex" }} onClick={this.showEmojiPicker} src={ImageUrl + "/social-feed/Emoji.png"}></img></div>
                    {this.props.companyBranding?.company_branding?.show_recognition ? <div style={{background:"white", width:"40px", height:"40px", borderRadius:"50%", display:"flex", marginRight:"10px"}}><img style={{  width: '25px', height: '25px', cursor: 'pointer', margin:"auto", display:"flex" }} src={ImageUrl + "/social-feed/recognition.png"} onClick={this.state.imgSrcArray.length===0&&!this.state.inspirationQuote&&this.state.userIdArrayV2.length===0?() => this.showRecognitionPopup():   () => this.showRecognitionPopupCall()}></img></div>: null}
                    <ImageSection width style={{display:"flex", background:"white", borderRadius:"50%"}}>
                      <UploadImage2 style={{ marginBottom: '0px', margin:"auto" }}>
                        <img src={ImageUrl + "/social-feed/cameraIcon.png"} alt={"social"} width="25px" height="25px"/>
                        <input
                          id="upload-file"
                          type="file"
                          name="user"
                          multiple={true}
                          onChange={(e) => this.onChange(e)}
                          accept=".jpeg, .png, .jpg"
                          hidden
                        />
                      </UploadImage2>
                    </ImageSection>

                  </div>
                </div>
              </div>
              <button className='post-btn' onClick ={this.state.imgSrcArray.length===0&&!this.state.inspirationQuote&&this.state.userIdArrayV2.length===0? null:this.addPost}>
                <div className='btn-title-main'>
                  <div className='btn-title'>{this.props.t("Post")}</div>
                  <img src='/public/images/post_feed_icon.svg'></img>
                </div>
              </button>
            </TopSection>
          </StyledBody>
        </StyledModal>
      </div>
    )
  }
}

SocialFeedV2.propTypes = {
  feeds: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  addSocialInspiration: PropTypes.func.isRequired,
  friendRequests: PropTypes.array.isRequired,
  acceptOrRejectFriendRequest: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  activityFeeds: PropTypes.array.isRequired,
  comments: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  fetchCommentsOnPost: PropTypes.func.isRequired,
  postReplyOnComment: PropTypes.func.isRequired,
  replySuccess: PropTypes.string,
  loadMoreFeeds: PropTypes.func.isRequired,
  wellnessExpert: PropTypes.object,
  iswbaTaken: PropTypes.bool.isRequired,
  profileImage: PropTypes.string,
  fetchUserProfileImage: PropTypes.func,
  count: PropTypes.number,
  role: PropTypes.string.isRequired,
  activeTab: PropTypes.string.isRequired,
  fetchUsersToShoutout: PropTypes.func,
  userCompany: PropTypes.object.isRequired,
  employeeData: PropTypes.array,
  enableTrigger: PropTypes.bool,
  userPermissions: PropTypes.array,
  companyId: PropTypes.number.isRequired,
  suggestionList: PropTypes.array,
  getSuggestionsList: PropTypes.func,
  user: PropTypes.object,
  devices: PropTypes.array,
  revokeDevice: PropTypes.func.isRequired,
  devicesDisconnected: PropTypes.array,
  dailyTip: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  exemplifiesValues: PropTypes.array,
  editDetails: PropTypes.any,
  editPostStatus: PropTypes.number,
  // addPost : PropTypes.func
  editSocialInspiration: PropTypes.func,
  postComment: PropTypes.func,
  addCommentWithImageStatus: PropTypes.number,
  feedIdForComment: PropTypes.any,
  commentId: PropTypes.any,
  t: PropTypes.func,
  getUserProfileDetails: PropTypes.func.isRequired,
  showRecognitionPopup: PropTypes.func,
  hidePhotoVideoPopup: PropTypes.func,
  handlePeerModal: PropTypes.func,
  companyBranding:PropTypes.object
};

const mapStateToProps = (state) => ({
  isLoading: state.social.isLoading,
  comments: state.social.comments,
  replySuccess: state.social.replySuccess,
  profileImage: state.profileData.profileImage,
  count: state.social.count,
  employeeData: state.peopleHome.employeeData,
  userCompany: state.profileData.userCompany,
  userPermissions: state.profileData.userPermissions,
  suggestionList: state.social.suggestionList,
  devices: state.wellnessDashboard.devices,
  devicesDisconnected: state.profileData.devicesDisconnected,
  dailyTip: state.profileData.dailyTip,
  exemplifiesValues: state.social.exemplifiesValues,
  user: state.profileData.user,
  companyBranding: state.wellnessDashboard.companyBrandingDetails,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUsersToShoutout: (data, cb) => dispatch(getUsersToShoutout(data, cb)),
  addSocialInspiration: (inspirationData) => dispatch(addSocialInspiration(inspirationData)),
  fetchCommentsOnPost: (id) => dispatch(getCommentsOnPost(id)),
  fetchUserProfileImage: () => dispatch(getUserProfileImage()),
  postReplyOnComment: (commentId, reply, postId, shoutout, shoutOutUserName, exemplify_id, image) => dispatch(addCommentReplyOnPost(commentId, reply, postId, shoutout, shoutOutUserName, exemplify_id, image)),
  getSuggestionsList: () => dispatch(getSuggestionsList()),
  revokeDevice: (name) => dispatch(revokeDevice(name)),
  editSocialInspiration: (postDetails, updationList) => dispatch(editSocialInspiration(postDetails, updationList)),
  postComment: (commentData, updationList) => dispatch(addCommentOnPost(commentData, updationList)),
  getUserProfileDetails: () => dispatch(getUserProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SocialFeedV2));